<template>
  <b-col 
    class="px-4 mt-3 mx-auto" 
    cols="12" md="10" lg='8'
  >
    <form 
      class="change-mail-form p-2 m-2"
      novalidate
    >
      <h4 class="mb-3 form-header">{{'userProfileDeleteLS' | localize}}:</h4>
      <div class=" mt-5 mb-5 delete-profile-description">
        {{'userProfileDeleteLSDescription' | localize}}
      </div>
      <div class="new-address-description ">{{'userProfileDeleteLSNumLs' | localize}}:</div>
      <b-form-select v-model="selected" class="mb-3">
        <b-form-select-option  :value="null">{{'userProfileDeleteLSNumbers' | localize}}</b-form-select-option>
        <b-form-select-option v-for="item of userAccountsNumbers" :key="item.index" :value="item.account_id">{{item.account_id}}</b-form-select-option>
      </b-form-select>
      <b-button
        class="mt-4 mb-3 style-button button-profile-width"
        variant="outline-danger"
        style="width: auto; padding-right: 35px;"
        @click="showMsgBoxOne"
      >
        {{'userProfileDeleteLS' | localize}} 
        <div class="style-button-icon">
          <b-icon  icon="trash" ></b-icon> 
        </div> 
      </b-button>
    </form>
    <b-modal @ok="deleteAccount" id="my-modal">{{'userProfileDeleteLSModalMessage' | localize}}
    <template v-slot:modal-ok> {{'userProfileDeleteLSModalOkButton' | localize}}</template>   
    <template v-slot:modal-cancel> {{'userProfileDeleteLSModalCancelButton' | localize}}</template> 
    </b-modal>
  </b-col>  
</template>
<script>
import config from '@/config'
const ROUTE_PREFIX = config.ROUTE_PREFIX
import { mapGetters } from 'vuex'
export default {
  data: ()=> ({
    selected: null,
    visible: false
  }),  
 async mounted(){
    await this.$store.dispatch('userAccountsFetch')
  },
  computed: mapGetters(['delete_ls_data', 'locale', 'userAccountsNumbers']),
  methods: {
    showMsgBoxOne() {
      if(this.selected == null){
        this.$messageLocalized("chooseAccountNumber")
      } else {
        this.$bvModal.show("my-modal")   
      }     
    },
    async deleteAccount(){
      await this.$store.dispatch('deleteLS', this.selected )
      this.$messageLocalized("accountDeleted")
      setTimeout( ()=> { this.$router.push( { path: `${ROUTE_PREFIX}/` } )}, 3000)
    }
  },
}
</script>